import { useEffect, useState } from "react";
import { io, Socket } from "socket.io-client";
import { SOCKET_CONFIG } from "../config/socket";
import type { UseDecibelReturn, DecibelData } from "../types";

const useDecibel = (): UseDecibelReturn => {
  const [decibelValue, setDecibelValue] = useState<number>(0);
  const [isConnected, setIsConnected] = useState<boolean>(false);
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    const newSocket = io(SOCKET_CONFIG.serverUrl, {
      path: SOCKET_CONFIG.path,
      transports: SOCKET_CONFIG.transports,
    });

    newSocket.on("connect", () => {
      console.log("🔊 Connected to WebSocket server");
      setIsConnected(true);
      newSocket.emit("decibel");
    });

    newSocket.on("disconnect", () => {
      console.log("🔌 Disconnected from WebSocket server");
      setIsConnected(false);
    });

    newSocket.on("decibel", (data: DecibelData) => {
      setDecibelValue(data.value);
    });

    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, []);

  const sendDecibelValue = (value: number): void => {
    if (socket && isConnected) {
      socket.emit("decibel_value", { value });
    }
  };

  return {
    decibelValue,
    isConnected,
    sendDecibelValue,
  };
};

export default useDecibel;
